<template>
  <div>
    <div
      v-if="!buynowData.Product.HideReview"
      class="_rfp_mctb_list_15_ rfp-mctb-star-rating-header"
    >
      <rfp-mctb-star-ratings
        :increment="1"
        :max-rating="5"
        :inactive-color="starInactiveColor"
        :active-color="starActiveColor"
        :star-size="starSize"
        :ratings="buynowData.Product.AverageReviews"
        :read-only="true"
        :show-rating="false"
      />

      <span class="rfp-mctb-star-rating-header-star-reviews">
        {{ buynowData.Product.RatingText }}
      </span>
    </div>

    <rfp-mctb-main-container
      :retailer-unavailable="retailerUnavailable"
      :buy-now="buyNow"
      :carousel-header="carouselHeader"
      :buynow-data="buynowData"
      :sport-lite-mode="false"
      :buy-online-button-text="buyOnlineButtonText"
      :buy-offline-button-text="buyOfflineButtonText"
      :enable-rtl="enableRtl"
      :component-diffs="componentDiffs"
      :use-commerce-connector="useCommerceConnector"
      :a11y="a11yLabels"
    />
  </div>
</template>

<script>
import RfpMctbStarRatings from './rfp-mctb-star-ratings/rfp-mctb-star-ratings.vue';
import RfpMctbMainContainer from './rfp-mctb-main-container.vue';
import { defaultA11yLabels } from '../base/prop-definitions.js';

export default {
  name: 'rfp-mctb-provider',
  components: {
    RfpMctbMainContainer,
    RfpMctbStarRatings,
  },
  props: {
    buynowData: {
      type: Object,
      required: true,
    },
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      default: 'Header Text',
    },
    buyNow: {
      type: String,
      default: 'Buy Now',
    },
    starInactiveColor: {
      type: String,
      default: '#000',
    },
    starActiveColor: {
      type: String,
      default: '#f00',
    },
    starSize: {
      type: Number,
      default: 25,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    componentDiffs: {
      type: Boolean,
      default: false,
    },
    retailerUnavailable: {
      type: String,
      default: 'unfortunatly no retailers are available at this moment.',
    },
    useCommerceConnector: {
      type: Boolean,
      required: true,
    },
    a11y: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    a11yLabels() {
      const a11yLabels = { ...defaultA11yLabels };
      Object.entries(this.a11y).forEach(([key, value]) => {
        if (value) {
          a11yLabels[key] = value;
        }
      });
      return a11yLabels;
    },
  },
};
</script>
